export default __webpack_public_path__ + "static/media/group.6ed71bbf.svg";